import React, {Component} from "react";
import PropTypes from "prop-types";
import SimpleFormBuilder from "../forms_builder/SimpleFormBuilder";
import utils from "../../utils/utils";
import Prototypes from "prop-types";
import {makeError} from "../modals/ErrorModal";
import {adminApi} from "../../services/ApiService";
import * as Yup from "yup";
import validationHelper from "../../utils/validationHelper";
import Constants from "../../utils/constants";
import AlertConfirm from "../modals/Confirm";
import SvGraphics from "../../assets/SvGraphics";

class ClinicEntryForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {},
            matrix: [1, 1,2,1,1, 1, 1, 1],
            errors: {},
            errorsOnSave: {}
        };
    }

    getFields = () => {
        let {t} = this.props
        return [
            {
                type: 'picture',
                max: 50,
                name: 'Clinic_PictureURL',
                placeholder: t('Clinic.form.Clinic_Pic'),
                display: t('Clinic.form.Clinic_Pic'),
                required: false,
                width: 0.6,
                style: 'inline'
            },
            {
                type: 'uploadField',
                max: 50,
                name: 'Clinic_Pic',
                placeholder: t('Clinic.form.Clinic_Pic'),
                display: '',
                required: false,
                width: 0.6,
                style: 'inline'
            },
            {
                type: 'text',
                max: 50,
                name: 'Clinic_Name',
                display: t('Clinic.form.clinic_name'),
                placeholder: t('Clinic.form.enter_clinic_name'),
                required: true,
                width: 0.5,
                style: 'inline'
            },
            {
                type: 'phone',
                name: 'Clinic_Phone_num',
                display: t('Clinic.form.clinic_phone_number'),
                placeholder: t('Clinic.form.clinic_phone_number'),
                required: false,
                width: 0.5,
                style: 'inline'
            },
            {
                type: 'text',
                max: 50,
                name: 'Clinic_Code',
                display: t('Clinic.form.Clinic_Code'),
                placeholder: t('Clinic.form.Clinic_Code'),
                required: true,
                width: 0.5,
                style: 'inline'
            },
            {type:'checkbox', name:'Is_Approving_Clinic',display: t('Clinic.form.Is_Approving_Clinic'), width:1, style:'block'},

            {
                type: 'text',
                max: 50,
                name: 'Clinic_Mail',
                display: t('Clinic.form.clinic_email'),
                placeholder: t('Clinic.form.enter_email'),
                required: true,
                width: 1,
                style: 'inline'
            },
            {
                type: 'textarea',
                max: 50,
                name: 'Clinic_Address',
                placeholder: t('Clinic.form.address'),
                display: t('Clinic.form.address'),
                required: false,
                width: 0.6,
                style: 'inline'
            },
            {
                type: 'textarea',
                max: 50,
                name: 'Clinic_Info',
                placeholder: t('Clinic.form.info'),
                display: t('Clinic.form.info'),
                required: false,
                width: 0.6,
                style: 'inline'
            },
            {type: 'default', name: 'none', placeholder: '', display: '', required: false, width: 0.4, style: 'inline'}
        ]
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            Clinic_Name: Yup.string().required(t('Clinic.form.clinic_name_req')),
            Clinic_Mail: Yup.string().matches(Constants.emailRegExp, t('Clinic.form.clinic_email_invalid')).required(t('Clinic.form.clinic_email_req')),
            Clinic_Code: Yup.string().required(t('Clinic.form.clinic_code_req')).test('len', t('Clinic.form.sexCharacters'), val => val.length === 6),
        })
        let errors = await validationHelper.validate(this.state.entry, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentDidMount() {

    }

    async componentWillMount() {
        if (this.props && this.props.entry) await this.setState({entry: this.props.entry})
        await this.initValidation()
    }

    async closeSideBar() {
        let {t} = this.props
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options: {
                title: t('Clinic.form.withdraw_new_clinic'),
            }
        }, t('Clinic.form.withdraw_new_clinic_info'))
        if (confirm) {
            document.body.style.overflow = "auto"
            this.props.closeSideBar(false)
            this.setState({entry: null})
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    async saveInfo() {
        let {t} = this.props
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            await makeError({
                proceedLabel: t('Clinic.form.ok'),
                options: {
                    title: t('Clinic.form.clinic_not_created'),
                }
            }, [t('Clinic.form.fill_all_req')]);
            return;
        }
        let {entry} = this.state
        document.body.style.overflow = "auto"
        let confirm = await AlertConfirm({
            options: {
                title: t('Clinic.form.add_new'),
            }
        }, `${t('Clinic.form.confirm_add_new')}: ${entry.Clinic_Name}?`)
        if (confirm) {
            entry = utils.ObjectEmptiesToNulls(entry)
            entry.Clinic_Code=""+entry.Clinic_Code
            let response = await adminApi.AddNewClinic(entry)
            if (response) {
                this.props.addNewClinic(response.data)
                document.body.style.overflow = "auto"
                this.props.closeSideBar(false)
                this.setState({entry: {}})
            }
        } else {
            document.body.style.overflow = "hidden"
        }
    }

    onPictureChange = async event => {
        let {entry} = this.state
        if (!entry.id) {
            let response = await adminApi.getClinicID()
            if (response) {
                entry['id'] = response.data
            }
        }
        if (event.target.files && event.target.files[0]) {
            let fileToAdd = {
                file: event.target.files[0],
                Clinic_ID: entry.id
            }
            let response = await adminApi.uploadProfilePng(fileToAdd)
            if (response) {
                utils.set(entry, "Clinic_PictureURL", response.data)
                this.setState({entry})

            }
        }
    }
    onEntryChange = async event => {
        let {entry, validationSchema} = this.state
        let name = event.target.name
        let value = event.target.type === 'checkbox' ?
            !entry[name]
            :event.target.value
        utils.set(entry, name, value)
        let entryValidator = utils.removeEmptyOrNull(entry)
        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }
        this.setState({
            entry,
            errors,
            errorsOnSave
        })
        //this.props.onEntryChange(entry)
    }

    render() {
        let display = this.props.isSideBarOpen ? 'block' : 'none'
        let width = this.props.isSideBarOpen ? "600px" : "0px"
        let container_width = this.props.isSideBarOpen ? "100%" : "0px"
        let {errorsOnSave} = this.state;
        let {t} = this.props
        return (
            <div className={"sidenav-complete"} style={{width: container_width, height: "100%"}}>
                <div className={"sidenav"} style={{width: width, height: "100%", float: 'right'}}>
                    <SvGraphics onClick={this.closeSideBar.bind(this)} className={'close-bar-x'} svgname={'close'}
                                height={'15px'} width={'15px'} style={{
                        float: 'left',
                        top: '10px',
                        left: '10px',
                        position: 'absolute',
                        cursor: 'pointer'
                    }}/>
                    <div className={'register-form-title container block'}>
                        <h3 className={'h-centered block'}>{this.props.title}</h3>
                    </div>
                    <div className={'register-form container block'}>
                        <SimpleFormBuilder
                            errors={errorsOnSave}
                            entry={this.state.entry}
                            matrix={this.state.matrix}
                            fields={this.getFields()}
                            onPictureChange={e => this.onPictureChange(e)}
                            onEntryChange={e => this.onEntryChange(e)}
                        />
                    </div>
                </div>
                <div className={'register-form-nav-container block'}  >
                    <div className={'register-form-nav'}  style={{width:width,display:'flex',justifyContent:"space-around"}}>
                        <button type={"button"} onClick={this.saveInfo.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.hcp.form.save')}
                        </button>
                        <button type={"button"} onClick={this.closeSideBar.bind(this)} style={{display:display}} className={"btn btn-primary save-info"}>
                            {t('admin.hcp.form.close')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

ClinicEntryForm.propTypes = {
    isSideBarOpen: Prototypes.bool.isRequired,
    addNewClinic: PropTypes.func.isRequired,
    closeSideBar: Prototypes.func.isRequired,
    title: Prototypes.string.isRequired,
    entry: Prototypes.object
}

export default ClinicEntryForm

